export const borderClasses100 =
  'border-slate-100 border-2 dark:border-slate-800';
export const borderClasses200 =
  'border-slate-200 border-2 dark:border-slate-700';
export const borderClasses300 =
  'border-slate-300 border-2 dark:border-slate-600';
export const borderClasses800 =
  'border-slate-800 border-2 dark:border-slate-200';

export const borderColor100 = 'border-slate-100 dark:border-slate-800';
export const borderColor200 = 'border-slate-200 dark:border-slate-700';
export const borderColor300 = 'border-slate-300 dark:border-slate-600';
export const borderColor400 = 'border-slate-400 dark:border-slate-500';

export const borderColorBlue100 = 'border-blue-100 dark:border-blue-800';
export const borderColorBlue200 = 'border-blue-200 dark:border-blue-700';
export const borderColorBlue300 = 'border-blue-300 dark:border-blue-600';
export const borderColorBlue400 = 'border-blue-400 dark:border-blue-500';
export const borderColorBlue500 = 'border-blue-500 dark:border-blue-400';
export const borderColorBlue600 = 'border-blue-600 dark:border-blue-300';
export const borderColorBlue700 = 'border-blue-700 dark:border-blue-300';

export const borderColorGray300 = 'border-gray-300 dark:border-gray-600';
export const borderColorGray350 = 'border-gray-350 dark:border-gray-600';
export const borderColorGray200 = 'border-gray-200 dark:border-gray-700';

export const borderInvert = `border-white dark:border-slate-800`;

export const borderGreen = `border-green-400`;
export const borderNeutral = 'border-neutral-700'; // ##404040
export const borderNeutral300 = 'border-neutral-300'; // #d4d4d4
export const borderNeutral200 = 'border-neutral-200'; // #e3e3e3

export const borderRed = 'border-red-500';

export const borderPlanPopular = 'border-wp-action-blue';
